// const getOrigin = function () {
//   if (
//     window.location.origin &&
//     window.location.origin.indexOf("localhost") !== -1
//   ) {
//     return "http://192.168.32.37:441/";
//   } else {
//     return window.location.origin;
//   }
// };

const getOrigin = function () {
  if (process.env.REACT_APP_STAGE == "dev") {
    return "https://devcfp.kiihealth.ca:441/";
    //return "http://192.168.32.37:1234/";
  } else if (process.env.REACT_APP_STAGE == "staging") {
    return "https://192.168.32.37:1123/";
  } else if (process.env.REACT_APP_STAGE == "prod") {
    return "https://disabilitymanagementportal.kiihealth.ca/";
  } else {
    return "http://192.168.32.37:442/";
    // return "http://192.168.32.37:4442/";
  }
};

const BASEURL = getOrigin();
const METHOD = {
  POST: "POST",
};
const apiConfig = { BASEURL, METHOD };

//Placeholders
export const POSTAL_CODE_PLACEHOLDER = "e.g. A1A 1A1";

export const PHONE_PLACEHOLDER = "e.g. (123)-456-7855";

export const EMAIL_PLACEHOLDER = "e.g. janedoe@canada.ca";

// export const ALPHANUMERICWITHSPACEREGEX = /^[a-zA-Z0-9 ]*$/;
export const ALPHANUMERICWITHSPACEREGEX = /^([ \u00c0-\u01ffa-zA-Z'\-])+$/;

export const ALPHANUMERICREGEX = /^[0-9a-zA-Z]+$/;

export const TEXTONLYREGEX = /^[a-zA-Z_ ]+$/;

export const POST_CODE_REGEX =
  /^[a-zA-Z][0-9][a-zA-Z]{1}(\s)[0-9][a-zA-Z][0-9]{1}$/;

export const NUMBERREGEX = /^[0-9]+$/;

export const TWODECIMAL_NUMBERREGEX = /^[0-9]*[.]?[0-9]{1,2}$/;

export const SPACE_NOT_ALLOWD = /^\S*$/;

export const PASSWORDREGEX =
  /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/;

export const NUMBER_FORMAT_REGEX = /^\(?[0-9]{3}\)?[-]([0-9]{3})[-]([0-9]{4})$/;

// export const EMAILREGEX = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/g;
export const EMAILREGEX = /(\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)/;

export const WEBSITEREGEX =
  /(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

export const DOMAINREGEX =
  /^((?!-))(xn--)?[a-z0-9][a-z0-9-_]{0,61}[a-z0-9]{0,1}\.(xn--)?([a-z0-9\-]{1,61}|[a-z0-9-]{1,30}\.[a-z]{2,})$/g;

// export const EMAILUSERNAMEREGEX = /^[a-zA-Z0-9](_(?!(\.|_))|\.(?!(_|\.))|\-(?!(_|\.))|[a-zA-Z0-9]){1,18}[a-zA-Z0-9]$/
export const EMAILUSERNAMEREGEX = /^(\w+([-+.']\w+)*)$/;

export const PHONE_TENDIGITS_REGEX = /^[0-9]{10}$/;

// export const TIMEREGEX  = /^([01][0-9]|2[0-3]):([0-5][0-9])$/
export const TIMEREGEX = /^(1[0-2]|0?[1-9]):[0-5][0-9]/;

export const ERROR_TIMEOUT = "10000";
export const DEFAULT_ERROR_MESSAGE = "Something went wrong!!";

export const ENGLISH = "English";
export const FRENCH = "French";

export const ENG_FRENCH = "Anglais";

export const INVALID_SESSION = "Invalid session.";

export const TOKEN_KEY = "AUTH_TOKEN";
export const CFP_State = "CFP_State";

export const DEFAULT_DOMAIN = "oncidium.ca";

export const CLAIMTYPE = {
  0: "-",
  1: "First aid only",
  2: "Medical aid only",
  3: "Lost time",
  4: "Modified Duties",
  5: "Near Miss",
};
export const CLAIMTYPE_FR = {
  0: "-",
  1: "Premiers soins seulement",
  2: "Traitement médical seulement",
  3: "Heures perdues",
  4: "Tâches modifiées",
  5: "Près de manquer",
};

//Validation Types

export const ValidationTypes = {
  TERMSANDCONDITION: "TermsAndCondition",
  REQUIRED: "required",
  MINLENGTH: "minLength",
  MAXLENGTH: "maxLength",
  MINSINLENGTH: "minSINLength",
  MATCHPATTERN: "matchPattern",
  CUSTOMMATCHPATTERN: "customMatchPattern",
  isDate: "isDate",
  isTime: "isTime",
  numeric: "numeric",
};

export const ValidaitonMessage = {
  Required: "Required",
  MinLength: "It should be",
  MaxLength: "It should not be",
  Invalid: "Invalid",
  CharacterLong: "character long",
};

export const APP_STATE_KEY = "CFP_State";

//Preffered Language Dropdown Data
export const PREFERREDLANGUAGEDRPDATA = [
  {
    LanguageId: "ENG",
    Language: "English",
  },
  {
    LanguageId: "CFR",
    Language: "French",
  },
  {
    LanguageId: "UNKNOWN",
    Language: "Unknown",
  },
];

export const EVENT_TYPE = [
  {
    ID: "Gradual onset",
    Val: "Gradual onset",
  },
  {
    ID: "Slip/trip/fall",
    Val: "Slip/trip/fall",
  },
  {
    ID: "MVA",
    Val: "MVA",
  },
  {
    ID: "Overexertion",
    Val: "Overexertion",
  },
  {
    ID: "Fatality",
    Val: "Fatality",
  },
  {
    ID: "Noise exposure",
    Val: "Noise exposure",
  },
  {
    ID: "Occupational disease",
    Val: "Occupational disease",
  },
  {
    ID: "Fire",
    Val: "Fire",
  },
  {
    ID: "Assault",
    Val: "Assault",
  },
];

export const EVENT_TYPE_FR = [
  {
    ID: "Gradual onset",
    Val: "Apparition graduelle",
  },
  {
    ID: "Slip/trip/fall",
    Val: "Glissade/Trip/Tombée",
  },
  {
    ID: "MVA",
    Val: "AVP",
  },
  {
    ID: "Overexertion",
    Val: "Surmenage",
  },
  {
    ID: "Fatality",
    Val: "Fatalité",
  },
  {
    ID: "Noise exposure",
    Val: "Exposition au bruit",
  },
  {
    ID: "Occupational disease",
    Val: "Maladie professionnelle",
  },
  {
    ID: "Fire",
    Val: "Incendie",
  },
  {
    ID: "Assault",
    Val: "Agression",
  },
];

export const PREFERREDLANGUAGEDRPDATA_FRENCH = [
  {
    LanguageId: "ENG",
    Language: "Anglais",
  },
  {
    LanguageId: "CFR",
    Language: "Français",
  },
];

//Language Keys
export const PREFERED_LANGUAGE_KEYS = {
  EnglishUS: "en-US",
  FrenchCanada: "fr-CA",
};

export const ALLOW_CHANGE_COMPANY_LOCATION = [
  "#/currentactivity",
  "#/applicants",
  "#/myreport",
];

//Type of claim
export const TYPEOFCLAIMDRPDATA = [
  {
    claimId: "First aid only",
    claimName: "First aid only",
  },
  {
    claimId: "Medical aid only",
    claimName: "Medical aid only",
  },
  {
    claimId: "Lost time",
    claimName: "Lost time",
  },
  {
    claimId: "Modified Duty",
    claimName: "Modified Duty",
  },
  {
    claimId: "Near Miss",
    claimName: "Near Miss",
  },
];

//Type of claim
export const TYPEOFCLAIMDRPDATA_FR = [
  {
    claimId: "First aid only",
    claimName: "Premiers soins seulement",
  },
  {
    claimId: "Medical aid only",
    claimName: "Soins médicaux seulement",
  },
  {
    claimId: "Lost time",
    claimName: "Temps perdu",
  },
  {
    claimId: "Modified Duty",
    claimName: "Tâches modifiées",
  },
  {
    claimId: "Near Miss",
    claimName: "Près de manquer",
  },
];

///Employee work shift
export const WORKSHIFTDRPDATA = [
  {
    shiftId: "Morning",
    shiftName: "Morning",
  },
  {
    shiftId: "Afternoon",
    shiftName: "Afternoon",
  },
  {
    shiftId: "Evening",
    shiftName: "Evening",
  },
  {
    shiftId: "Rotating",
    shiftName: "Rotating",
  },
  {
    shiftId: "Other",
    shiftName: "Other",
  },
];

///Employee work shift
export const WORKSHIFTDRPDATA_FR = [
  {
    shiftId: "Morning",
    shiftName: "Matinée",
  },
  {
    shiftId: "Afternoon",
    shiftName: "Après-midi",
  },
  {
    shiftId: "Evening",
    shiftName: "Soirée",
  },
  {
    shiftId: "Rotating",
    shiftName: "Quart rotatif",
  },
  {
    shiftId: "Other",
    shiftName: "Autre",
  },
];

//Employment status
export const EMPLOYEESTATUSDRPDATA = [
  {
    employmentStatusId: "Permanent Full Time",
    employmentStatusName: "Permanent Full Time",
  },
  {
    employmentStatusId: "Permanent Part Time",
    employmentStatusName: "Permanent Part Time",
  },
  {
    employmentStatusId: "Temporary Full Time",
    employmentStatusName: "Temporary Full Time",
  },
  {
    employmentStatusId: "Temporary Part Time",
    employmentStatusName: "Temporary Part Time",
  },
  {
    employmentStatusId: "Casual/irregular",
    employmentStatusName: "Casual/irregular",
  },
  {
    employmentStatusId: "Seasonal",
    employmentStatusName: "Seasonal",
  },
  {
    employmentStatusId: "Contract",
    employmentStatusName: "Contract",
  },
  {
    employmentStatusId: "Student",
    employmentStatusName: "Student",
  },
  {
    employmentStatusId: "Unpaid/Trainee",
    employmentStatusName: "Unpaid/Trainee",
  },
  {
    employmentStatusId: "Registered Apprentice",
    employmentStatusName: "Registered Apprentice",
  },
  {
    employmentStatusId: "Optional Insurance",
    employmentStatusName: "Optional Insurance",
  },
  {
    employmentStatusId: "Owner Operation or (sub) Contractor",
    employmentStatusName: "Owner Operation or (sub) Contractor",
  },
  {
    employmentStatusId: "Other",
    employmentStatusName: "Other",
  },
];

//Employment status
export const EMPLOYEESTATUSDRPDATA_FR = [
  {
    employmentStatusId: "Permanent Full Time",
    employmentStatusName: "Permanent à temps plein",
  },
  {
    employmentStatusId: "Permanent Part Time",
    employmentStatusName: "Temps partiel permanent",
  },
  {
    employmentStatusId: "Temporary Full Time",
    employmentStatusName: "Temporaire à temps plein",
  },
  {
    employmentStatusId: "Temporary Part Time",
    employmentStatusName: "Temporaire à temps partiel",
  },
  {
    employmentStatusId: "Casual/irregular",
    employmentStatusName: "Occasionnel/Irrégulier",
  },
  {
    employmentStatusId: "Seasonal",
    employmentStatusName: "Saisonnier",
  },
  {
    employmentStatusId: "Contract",
    employmentStatusName: "Contrat",
  },
  {
    employmentStatusId: "Student",
    employmentStatusName: "Étudiant",
  },
  {
    employmentStatusId: "Unpaid/Trainee",
    employmentStatusName: "Non rémunéré/stagiaire",
  },
  {
    employmentStatusId: "Registered Apprentice",
    employmentStatusName: "Apprenti enregistré",
  },
  {
    employmentStatusId: "Optional Insurance",
    employmentStatusName: "Assurance facultative",
  },
  {
    employmentStatusId: "Owner Operation or (sub) Contractor",
    employmentStatusName: "Propriétaire exploitant ou (sous)-entrepreneur",
  },
  {
    employmentStatusId: "Other",
    employmentStatusName: "Autre",
  },
];

//Employment status
export const RegularWorkSchedule = [
  {
    RegularWorkScheduleId: "Sunday",
    RegularWorkScheduleValue: "Sunday",
  },
  {
    RegularWorkScheduleId: "Monday",
    RegularWorkScheduleValue: "Monday",
  },
  {
    RegularWorkScheduleId: "Tuesday",
    RegularWorkScheduleValue: "Tuesday",
  },
  {
    RegularWorkScheduleId: "Wednesday",
    RegularWorkScheduleValue: "Wednesday",
  },
  {
    RegularWorkScheduleId: "Thursday",
    RegularWorkScheduleValue: "Thursday",
  },
  {
    RegularWorkScheduleId: "Friday",
    RegularWorkScheduleValue: "Friday",
  },
  {
    RegularWorkScheduleId: "Saturday",
    RegularWorkScheduleValue: "Saturday",
  },
];

export const workHasEmployeeReturned = [
  {
    typeOfWorkId: "Full-time Regular",
    typeOfWork: "Full-time Regular",
  },
  {
    typeOfWorkId: "Full-time Modified",
    typeOfWork: "Full-time Modified",
  },
  {
    typeOfWorkId: "Part-time Regular",
    typeOfWork: "Part-time Regular",
  },
  {
    typeOfWorkId: "Part-time Modified",
    typeOfWork: "Part-time Modified",
  },
];

export const workHasEmployeeReturned_FRENCH = [
  {
    typeOfWorkId: "Full-time Regular",
    typeOfWork: "Temps Plein Régulier",
  },
  {
    typeOfWorkId: "Full-time Modified",
    typeOfWork: "Temps Plein Modifié",
  },
  {
    typeOfWorkId: "Part-time Regular",
    typeOfWork: "Temps Partiel Régulier",
  },
  {
    typeOfWorkId: "Part-time Modified",
    typeOfWork: "Temps partiel Modifié",
  },
];

export const TYPEOFRTWTOCOMPAREWITH = [
  "Full-time Modified",
  "Part-time Modified",
  "Temps Plein Modifié",
  "Temps partiel Modifié",
];

export const COUNTRYDRPDATA = [
  { countryId: 1, countryName: "Canada" },
  { countryId: 2, countryName: "US" },
];

export const AIR_RETURNTOWORK = [
  {
    workReturnToId: "Pre-accident",
    workReturnToName: "Pre-accident",
  },
  {
    workReturnToId: "Modified",
    workReturnToName: "Modified",
  },
  {
    workReturnToId: "Other",
    workReturnToName: "Other",
  },
];

export const RETURNTOWORK = [
  { fileStatusId: "Full-time Regular", fileStatusName: "Full-time Regular" },
  { fileStatusId: "Full-time Modified", fileStatusName: "Full-time Modified" },
  { fileStatusId: "Part-time Regular", fileStatusName: "Part-time Regular" },
  { fileStatusId: "Part-time Modified", fileStatusName: "Part-time Modified" },
];

export const PROVINCEDRPDATA = [
  { stateId: 1, countryId: 1, stateName: "Alberta" },
  { stateId: 2, countryId: 1, stateName: "British Columbia" },
  { stateId: 3, countryId: 1, stateName: "Manitoba" },
  { stateId: 4, countryId: 1, stateName: "New Brunswick" },
  { stateId: 5, countryId: 1, stateName: "Newfoundland and Labrador" },
  { stateId: 6, countryId: 1, stateName: "Nova Scotia" },
  { stateId: 7, countryId: 1, stateName: "Ontario" },
  { stateId: 8, countryId: 1, stateName: "Prince Edward Island" },
  { stateId: 9, countryId: 1, stateName: "Quebec" },
  { stateId: 10, countryId: 1, stateName: "Saskatchewan" },
];

export const LOCATION_DIVISION_DATA = [
  { value: "Calgary", text: "Calgary" },
  { value: "Edmontion", text: "Edmontion" },
  { value: "New Bramption", text: "New Bramption" },
  { value: "Toronto", text: "Toronto" },
  { value: "Other", text: "Other" },
];

export const userAdminCredential = {
  emailid: "user@admin.com",
  password: "admin@123",
};

export const ADMIN_ROLES_FOR_ADMIN_SECTION = [
  {
    authUserRoleId: 1,
    name: "Administrator",
    fr_name: "Administrator",
    uniqueSlug: "PM0F6B",
  },
  {
    authUserRoleId: 2,
    name: "FULL HR",
    fr_name: "Accès RH",
    uniqueSlug: "4XV2GK",
  },
  {
    authUserRoleId: 3,
    name: "LIMITED CAL HR",
    fr_name: "Accès RH",
    uniqueSlug: "S0GLM4",
  },
  {
    authUserRoleId: 4,
    name: "MANAGER",
    fr_name: "Accès au gestionnaire",
    uniqueSlug: "FOSDSM",
  },
  {
    authUserRoleId: 5,
    name: "Broker",
    fr_name: "Courtier",
    uniqueSlug: "BXFGDM",
  },
];

export const TITLEDRPDATA = [
  {
    tittleId: 1,
    tittleName: "Mr",
  },
  { tittleId: 2, tittleName: "Mrs." },
  { tittleId: 3, tittleName: "Ms" },
];

export const COMPANYDRPDATA = [
  {
    companyId: 1,
    companyName: "AAAA",
  },
  { companyId: 2, companyName: "BBBB" },
  { companyId: 3, companyName: "CCCC" },
];

export const CITYDRPDATA = [
  {
    cityId: 1,
    cityName: "Toronto",
  },
  { cityId: 2, cityName: "Calgary" },
  { cityId: 3, cityName: "Alberta" },
];

export const JOBDRPDATA = [
  {
    jobId: 1,
    jobName: "AAA",
  },
];

export const PLANLINKDRPDATA = [
  {
    PlanLinkId: 1,
    planLinkName: "TEST",
  },
];

export const COMPANYID = 62;

export const STDLTDDRPDATA = [
  { stdLtdId: "STD", stdLtdName: "STD Case" },
  { stdLtdId: "LTD", stdLtdName: "LTD Case" },
];

export const SERVICETYPEDRPDATA = [
  { serviceTypeId: "STD", serviceType: "STD" },
  { serviceTypeId: "CCM", serviceType: "CCM" },
  { serviceTypeId: "DCM-Special", serviceType: "DCM-Special" },
  { serviceTypeId: "Absence Management", serviceType: "Absence Management" },
];

export const SERVICETYPEDRPDATA_ACC = [
  { serviceTypeId: "ACMD", serviceType: "Accommodation" },
];

export const SERVICETYPEDRPDATA_CCM = [
  {
    serviceTypeId: "Complex Case Management",
    serviceType: "Complex Case Management",
  },
  { serviceTypeId: "Casual Absence", serviceType: "Casual Absence" },
  { serviceTypeId: "DCM-Special", serviceType: "DCM-Special" },
  { serviceTypeId: "MDSD", serviceType: "MDSD" },
];

//Time-picker Format
export const format = "h:mm a";

//Language Confirmation modal
export const CONFIRMATION_MESSAGE =
  "Do you wish to proceed in English or French?";
export const CONFIRMATION_HEADER = "Language Confirmation";

//Delete modal
export const CONFIRMATION_DELETE_HEADER = "Confirmation";
export const CONFIRMATION_DELETE_MESSAGE =
  "Are you sure do you want to delete?";

//Reset Password modal
export const RESET_PASSWORD_HEADER =
  "Reset Password / Modifier le mot de passe";

//Preffered Language
export const PREFFEREDLANGUAGE = "Preferred Language";
export const NOT_SELECTED = "Not Selected";

//Last login Details
export const LASTLOGINDETAILS = "Last Login Details";

//File History title
export const FILEHISTORYINFO = "File History Information";

//Job Details
export const JOB_DETAILS_HEADER = "Add New Job Title";

//Change Password
export const CHANGE_PASSWORD_HEADER = "Update Password";
export const PASSWORD_ERROR =
  "Password should be 8 Character long with 1 Uppercase, 1 numeric and 1 Special Character.";
export const PASSWORD_NOT_SAME_ERROR = "Both password should be same";

//Terms and Condition
export const TERMSANDCONDITION_HEADER = "Terms and Conditions / Modalités";

/// Alert Error message
export const ALERT_ERROR_MESSAGE = "Form submission invalid!";

///Errors
export const STRING_TYPE = "string";

export const VALUE_NOT_VALID = "This value is not valid";

export const TEXT_VALUE_ERROR = "Only alphabetical values are allowed";

export const NUMERIC_VALUE_ERROR = "Only numeric values are allowed";

export const EIN_ERROR = "Please Enter EIN";

export const PAGINATION_NO_OF_PAGES_TO_BE_DISPLAY = 5;

//initial pagination
export const initialPagination = { pageNo: 1, pageSize: 10, totalRows: 0 };

//initial pagination for ers
export const ersInitialPagination = { pageNo: 1, pageSize: 20, totalRows: 0 };

//initial pagination for air applicantions
export const airInitialPagination = { pageNo: 1, pageSize: 20, totalRows: 0 };

//initial pagination for Case status
export const caseStatusInitialPagination = {
  pageNo: 1,
  pageSize: 10,
  totalRows: 0,
};

export const PAGE_SIZE_DRP = [
  { pageSize: 10, pageSizeValue: 10 },
  { pageSize: 20, pageSizeValue: 20 },
  { pageSize: 50, pageSizeValue: 50 },
  { pageSize: 100, pageSizeValue: 100 },
];

export const ATTACHMENT_FILTER = [
  { ID: null, Value: "All Documents" },
  { ID: false, Value: "Form Submissions" },
  { ID: true, Value: "Attachments" },
];

export const ATTACHMENT_FILTER_FR = [
  { ID: null, Value: "Tous les documents" },
  { ID: false, Value: "Soumission des formulaires" },
  { ID: true, Value: "Attachments" },
];

export const LEVELS = [
  { ID: 1, Value: "Level 1" },
  { ID: 2, Value: "Level 2" },
  { ID: 3, Value: "Level 3" },
  { ID: 4, Value: "Level 4" },
  { ID: 5, Value: "Level 5" },
  { ID: 6, Value: "Level 6" },
  { ID: 7, Value: "Level 7" },
  { ID: 8, Value: "Level 8" },
  { ID: 9, Value: "Level 9" },
  { ID: 10, Value: "Level 10" },
  { ID: 11, Value: "Level 11" },
  { ID: 12, Value: "Level 12" },
  { ID: 13, Value: "Level 13" },
  { ID: 14, Value: "Level 14" },
  { ID: 15, Value: "Level 15" },
  { ID: 16, Value: "Level 16" },
];

export const CASE_TYPE_WITH_DISPLAYSTATUS = [
  { overAllStatusItem: "STD - FDA", displayValue: "STD" },
  ,
  { overAllStatusItem: "REO - FDA", displayValue: "FDA" },
  { overAllStatusItem: "DCM – Special", displayValue: "DCM" },
  {
    overAllStatusItem: "Accommodation - Assessment",
    displayValue: "Accommodation",
  },
  { overAllStatusItem: "REO - Occ-Inj/Acc", displayValue: "Occ/Inj" },
  { overAllStatusItem: "Occ - Inj/Acc", displayValue: "Occ - Inj/Acc" },
  { overAllStatusItem: "Closed", displayValue: "Closed" },
  { overAllStatusItem: "Complex Case Mgmt (CCM)", displayValue: "CCM" },
  { overAllStatusItem: "LTD - FDA", displayValue: "LTD" },
  {
    overAllStatusItem: "Accommodation - Closed",
    displayValue: "Accommodation",
  },
  {
    overAllStatusItem: "Accommodation - Opened",
    displayValue: "Accommodation",
  },
  { overAllStatusItem: "RTW - P/T Regular Duties", displayValue: "RTW" },
  { overAllStatusItem: "RTW - F/T Modified Duties", displayValue: "RTW" },
  { overAllStatusItem: "RTW - F/T Regular Duties", displayValue: "RTW" },
];

export class CASE_STATUS {
  static STD_FDA = "STD - FDA";
  static REO_FDA = "REO - FDA";
  static DCM_SPECIAL = "DCM – Special";
  static ACCOMODATION_ASSESMENT = "Accommodation - Assessment";
  static REO_OCC_INJ_ACC = "REO - Occ-Inj/Acc";
  static OCC_INJ_ACC = "Occ - Inj/Acc";
  static CLOSED = "Closed";
  static Complex_CASE_MGMT_CCM = "Complex Case Mgmt (CCM)";
  static LTD_FDA = "LTD - FDA";
  static ACCOMODATION_CLOSED = "Accommodation - Closed";
  static ACCOMODATION_OPENED = "Accommodation - Opened";
  static RTW_P_T_REGULAR_DUTIES = "RTW - P/T Regular Duties";
  static RTW_F_T_MODIFIED_DUTIES = "RTW - F/T Modified Duties";
  static RTW_F_T_REGULAR_DUTIES = "RTW - F/T Regular Duties";

  static isAccomodation(status) {
    return (
      status == this.ACCOMODATION_ASSESMENT ||
      status == this.ACCOMODATION_OPENED ||
      status == this.ACCOMODATION_CLOSED
    );
  }

  static isStd(status) {
    return (
      status == this.STD_FDA ||
      status == this.DCM_SPECIAL ||
      status == this.OCC_INJ_ACC
    );
  }

  static isCCM(status) {
    return status == this.Complex_CASE_MGMT_CCM;
  }

  static getInitialStatus = (statusList, fileStatus) => {
    return statusList.length
      ? statusList[statusList.length - 1].statusName
      : fileStatus;
  };
}

export class MODAL_SIZE {
  static MODAL_LG = "lg";
  static MODAL_MD = "md";
  static MODAL_SM = "sm";
}

export class USER_ROLES {
  static ADMIN = 1;
  static FULL_HR = 2;
  static LIMITED_CAL_HR = 3;
  static LIMITED_CAL_MGR = 4;
  static BROKER = 5;
}

export const EXCEPTIONALURL = ["#/air"];

//Report download config
export const PDF_DOWNLOAD = 1;
export const EXCEL_DOWNLOAD = 2;

export default apiConfig;

export class REPORT_MODULES {
  static STD = 1;
  static ACCM = 2;
  static CCM = 3;
  static LTD = 4;
  static WORKER_COMP = 5;
}
